import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import { use } from "i18next";
import { useEffect, useState } from "react";
import React, { useParams } from "react-router-dom";

const Unsubscribe = () => {
    const { uid } = useParams<{ uid: string }>();
    const { fetchData } = useFetchDataV2('');
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {

        fetchData(`${import.meta.env.VITE_IP_API}/unsubscribe/${uid}`).then(res => {
            if(res && res.success) {
                setLoading(false);
            } else {
                window.location.href = '/dashboard';
            }
        })

    }, []);

    if(loading) {
        return <div className="mt-10 ml-5">
            <LoadingSpinner />
        </div>
    }

    return (
        <div className="mt-10 text-center">
            <p className="text-gray-800 text-[18px]">Vous êtes maintenant désabonné de toutes les notifications.</p>
            <p className="text-gray-800 text-[15px] mt-4 underline"><a href="/dashboard">Retourner à l'application</a></p>
        </div>
    );

};

export default Unsubscribe;
